import { Button, Modal } from "antd";
import SVGIcon from "../../../../utils/SVGIcon";
import { resetStore } from "../../../../features/auth/apiService";

const Logout = ({ open, close }) => {
  const handleSubmit = () => {
    resetStore();
  };

  return (
    <Modal
      title="Logout"
      width={540}
      open={open}
      onCancel={close}
      centered
      closeIcon={<SVGIcon icon="cross" />}
      //   wrapClassName="signatureModal"
      footer={[
        <Button key="1" type="default" size="large" onClick={close}>
          Cancel
        </Button>,
        <Button
          form="logoutForm"
          key="2"
          type="primary"
          size="large"
          htmlType="submit"
          onClick={handleSubmit}
        >
          Logout
        </Button>,
      ]}
    >
      <div className="deleteMsg">
        <p> Are you sure want to logout?</p>
      </div>
    </Modal>
  );
};

export default Logout;
